import type { TranCopKnownEnv, TranCopUploadOrigin } from './types'

export const KNOWN_ENVS = ['dev', 'uat', 'prod'] as const

export const KNOWN_ORIGINS = [
  'paas-dev',
  'paas-uat',
  'paas-hk',

  'saas-uat',
  'saas-hk',
  'saas-fra',
] as const

export const ORIGIN_MAP: Record<TranCopUploadOrigin, string> = {
  'paas-dev': 'https://dev-paas.transsion.com/datakit/',
  'paas-uat': 'https://uat-paas.transsion.com/datakit/',
  'paas-hk': 'https://hk-paas.transsion.com/datakit/',

  'saas-uat': 'https://cn6-rum-openway.guance.com/',
  'saas-hk': 'https://cn6-rum-openway.guance.com/',
  'saas-fra': 'https://eu1-rum-openway.guance.com/',
}

export const DEFAULT_ENV_ORIGIN_MAP: Record<TranCopKnownEnv, TranCopUploadOrigin> = {
  dev: 'paas-dev',
  uat: 'paas-uat',
  prod: 'paas-hk',
}
